<template>
	<section class="member-orders">
		<el-card shadow="never" class="member-orders__container">
			<div slot="header" class="member-orders__header">
				<div>
					<h3>订单管理</h3>
					<p>查看最近订单，支持快捷筛选与分页</p>
				</div>
				<div class="member-orders__metrics">
					<div class="metric">
						<div class="metric__label">总订单</div>
						<div class="metric__value">
							{{ stats.totalOrders }}
						</div>
					</div>
					<!-- <div class="metric">
						<div class="metric__label">累计金额</div>
						<div class="metric__value">
							￥{{ formatAmount(stats.totalAmount) }}
						</div>
					</div>
					<div class="metric">
						<div class="metric__label">待支付</div>
						<div class="metric__value metric__value--warning">
							{{ stats.pendingPayment }}
						</div>
					</div> -->
				</div>
			</div>

			<div class="member-orders__filters">
				<el-form :inline="true" size="small">
					<el-form-item label="订单日期">
						<el-date-picker
							v-model="filters.dateRange"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
							:picker-options="datePickerOptions"
						/>
					</el-form-item>
					<el-form-item label="订单状态">
						<el-select v-model="filters.status" placeholder="全部状态" clearable>
							<el-option label="全部状态" value="" />
							<el-option
								v-for="item in statusOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleSearch" :loading="loading">
							查询
						</el-button>
						<el-button @click="handleReset" :disabled="loading">
							重置
						</el-button>
					</el-form-item>
				</el-form>
				<!-- 快捷筛选暂时隐藏，因为数量统计不准确 -->
				<!-- <div class="member-orders__quick">
					<el-button
						v-for="filter in quickFilters"
						:key="filter.value"
						size="mini"
						:type="filters.status === filter.value ? 'primary' : 'default'"
						round
						@click="applyQuickFilter(filter.value)"
					>
						{{ filter.label }}
						<el-tag
							type="info"
							size="mini"
							effect="plain"
							style="margin-left: 6px"
						>
							{{ statusCounts[filter.value] || 0 }}
						</el-tag>
					</el-button>
				</div> -->
			</div>

			<el-alert
				v-if="usingDemo || isUsingTestUser()"
				type="warning"
				show-icon
				closable
				class="member-orders__notice"
				:title="`当前展示演示账号订单（BookerID: ${demoBookerId || getBookerID()}）`"
				description="演示数据仅供查看效果，登录后可获取您的真实订单"
			/>

			<el-alert
				v-if="usingMock"
				type="info"
				show-icon
				closable
				class="member-orders__notice"
				title="当前展示示例数据，登录后可查看真实订单"
			/>

			<el-alert
				v-if="isEmptyData && !usingMock && !usingDemo"
				type="info"
				show-icon
				closable
				class="member-orders__notice"
				title="暂无订单数据"
				:description="emptyDataMessage"
			/>

			<el-table
				v-loading="loading"
				:data="orderRows"
				size="small"
				border
				:empty-text="isEmptyData ? '暂无订单数据' : '暂无订单'"
			>
				<el-table-column prop="orderNo" label="订单号" width="160">
					<template slot-scope="{ row }">
						<div class="order-no">
							<el-link
								type="primary"
								:underline="false"
								@click="viewOrderDetail(row)"
								class="order-no-link"
							>
								{{ row.orderNo }}
							</el-link>
							<el-tag
								size="mini"
								:type="getProductTagType(row.productCategoryId)"
								effect="plain"
								style="margin-left: 6px"
							>
								{{ row.productCategoryCName || orderTypeLabel(row.type) }}
							</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="trip" label="行程 / 产品" min-width="220">
					<template slot-scope="{ row }">
						<div class="order-trip">
							{{ row.trip || '-' }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="bookerName" label="预订员" width="120" />
				<el-table-column prop="amount" label="金额" width="110" align="right">
					<template slot-scope="{ row }">
						<span class="order-amount">
							￥{{ formatAmount(row.amount) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" width="100" align="center">
					<template slot-scope="{ row }">
						<el-tag :type="statusColor(row.status)" effect="dark" size="small">
							{{ row.statusText || row.status || '未知状态' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createdAt" label="创建时间" width="150">
					<template slot-scope="{ row }">
						<div class="order-date">
							{{ formatDate(row.createdAt) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="100" align="center">
					<template slot-scope="{ row }">
						<el-button type="text" size="mini" @click="viewOrderDetail(row)">
							详情
						</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div class="member-orders__pagination" v-if="pagination.total > 0">
				<!-- 只有当总数大于每页条数时才显示分页控件 -->
				<el-pagination
					v-if="pagination.total > pagination.pageSize"
					:current-page="pagination.page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pagination.pageSize"
					layout="prev, pager, next, sizes, jumper, total"
					:total="pagination.total"
					@size-change="handlePageSize"
					@current-change="handlePageChange"
				/>
				<!-- 如果总数小于等于每页条数，显示简单提示 -->
				<div v-else style="text-align: center; color: #909399; padding: 10px;">
					共 {{ pagination.total }} 条记录，全部显示
				</div>
			</div>
		</el-card>
	</section>
</template>

<script>
import moment from 'moment'
import { fetchOrders as fetchMemberOrders } from '../services/memberCenterService'
import { getBookerID, isUsingTestUser } from '@/utils/util'

export default {
	name: 'MemberOrders',
	props: {
		orders: {
			type: Array,
			default: () => []
		}
	},
	data() {
		const defaultRange = [
			moment().subtract(30, 'days').format('YYYY-MM-DD'),
			moment().format('YYYY-MM-DD')
		]
		return {
			loading: false,
			usingMock: false,
			usingDemo: false,
			demoBookerId: '',
			orderRows: [],
			isEmptyData: false,
			emptyDataMessage: '当前筛选条件下暂无订单，请尝试调整筛选条件或日期范围',
			stats: {
				totalOrders: 0,
				totalAmount: 0,
				pendingPayment: 0
			},
			statusCounts: {},
			filters: {
				status: '',
				dateRange: defaultRange
			},
			pagination: {
				page: 1,
				pageSize: 10,
				total: 0
			},
			quickFilters: [
				{ label: '全部', value: '' },
				{ label: '待支付', value: '待支付' },
				{ label: '已支付', value: '已支付' },
				{ label: '已出票', value: '已出票' },
				{ label: '已取消', value: '已取消' }
			],
			statusOptions: [
				{ label: '待支付', value: '待支付' },
				{ label: '已支付', value: '已支付' },
				{ label: '已出票', value: '已出票' },
				{ label: '已取消', value: '已取消' },
				{ label: '已完成', value: '已完成' }
			],
			datePickerOptions: {
				disabledDate(time) {
					const today = moment().endOf('day')
					return time.getTime() > today.valueOf()
				}
			}
		}
	},
	watch: {
		orders: {
			immediate: true,
			handler(value) {
				if (Array.isArray(value) && value.length && !this.orderRows.length) {
					this.orderRows = value
				}
			}
		}
	},
	created() {
		this.fetchOrders()
	},
	methods: {
		async fetchOrders(extra = {}) {
			this.loading = true
			try {
				const { dateRange, status } = this.filters
				const page = extra.page !== undefined ? extra.page : this.pagination.page
				const pageSize = extra.pageSize !== undefined ? extra.pageSize : this.pagination.pageSize
				
				console.log('[Orders] 请求参数:', { page, pageSize, status, dateRange })

				const result = await fetchMemberOrders({
					startDate: dateRange?.[0],
					endDate: dateRange?.[1],
					status,
					page,
					pageSize
				})

				console.log('[Orders] API 返回:', {
					total: result.total,
					listLength: result.list?.length,
					source: result.source,
					isEmpty: result.isEmpty,
					totalType: typeof result.total,
					paginationBefore: {
						page: this.pagination.page,
						pageSize: this.pagination.pageSize,
						total: this.pagination.total
					}
				})

				this.orderRows = result.list || []
				// 确保total是一个有效的数字，优先使用TotalResults
				const totalValue = parseInt(result.total) || parseInt(result.TotalResults) || 0
				this.pagination.total = totalValue
				this.pagination.page = page
				this.pagination.pageSize = pageSize

				// 判断是否为空数据（不是 mock 数据，且列表为空）
				this.isEmptyData = result.isEmpty === true && result.source !== 'mock'

				// 根据筛选条件生成空数据提示信息
				if (this.isEmptyData) {
					const hasFilter = this.filters.status || 
						(this.filters.dateRange && 
						 (this.filters.dateRange[0] !== moment().subtract(30, 'days').format('YYYY-MM-DD') ||
						  this.filters.dateRange[1] !== moment().format('YYYY-MM-DD')))
					if (hasFilter) {
						this.emptyDataMessage = '当前筛选条件下暂无订单，请尝试调整筛选条件或日期范围'
					} else {
						this.emptyDataMessage = '您还没有订单记录，下单后可以在这里查看'
					}
				}

				console.log('[Orders] 分页更新后:', {
					pagination: this.pagination,
					resultTotal: result.total,
					resultTotalResults: result.TotalResults,
					finalTotal: totalValue,
					willShowPagination: this.pagination.total > this.pagination.pageSize,
					orderRowsCount: this.orderRows.length,
					isEmptyData: this.isEmptyData
				})
				this.stats = result.statistics || {
					totalOrders: result.total || 0,
					totalAmount: (result.list || []).reduce(
						(sum, item) => sum + (item.amount || 0),
						0
					),
					pendingPayment: (result.list || []).filter(item =>
						['待支付', 'UnPay'].includes(item.status)
					).length
				}
				this.statusCounts = result.statusCounts || {}
				this.usingMock = result.source === 'mock'
				this.usingDemo = result.source === 'demo'
				this.demoBookerId = result.meta?.bookerId || ''
			} catch (error) {
				console.error('加载订单失败', error)
				
				// 判断错误类型
				const isNetworkError = !error.response && error.message
				const isServerError = error.response && error.response.status >= 500
				const isAuthError = error.response && (error.response.status === 401 || error.response.status === 403)
				
				// 根据错误类型显示不同的提示
				if (isAuthError) {
					this.$message.warning('登录已过期，请重新登录')
					this.isEmptyData = true
					this.emptyDataMessage = '请先登录后查看订单'
					this.orderRows = []
					this.pagination.total = 0
					this.stats = {
						totalOrders: 0,
						totalAmount: 0,
						pendingPayment: 0
					}
					this.usingMock = false
					this.usingDemo = false
				} else if (isNetworkError || isServerError) {
					// 网络错误或服务器错误，尝试使用 mock 数据作为后备
					this.$message.warning('网络连接异常，正在加载示例数据')
					try {
						const fallback = await fetchMemberOrders({
							forceMock: true,
							page: this.pagination.page,
							pageSize: this.pagination.pageSize
						})
						this.orderRows = fallback.list || []
						this.pagination.total = fallback.total || 0
						this.stats = fallback.statistics || {
							totalOrders: fallback.total || 0,
							totalAmount: 0,
							pendingPayment: 0
						}
						this.statusCounts = fallback.statusCounts || {}
						this.usingMock = true
						this.usingDemo = false
						this.isEmptyData = false
					} catch (fallbackError) {
						console.error('加载示例数据也失败', fallbackError)
						this.$message.error('数据加载失败，请稍后重试')
						this.isEmptyData = true
						this.emptyDataMessage = '数据加载失败，请检查网络连接后重试'
						this.orderRows = []
						this.pagination.total = 0
						this.stats = {
							totalOrders: 0,
							totalAmount: 0,
							pendingPayment: 0
						}
						this.usingMock = false
						this.usingDemo = false
					}
				} else {
					// 其他错误
					this.$message.error('获取订单数据失败，请稍后重试')
					this.isEmptyData = true
					this.emptyDataMessage = '数据加载失败，请稍后重试'
					this.orderRows = []
					this.pagination.total = 0
					this.stats = {
						totalOrders: 0,
						totalAmount: 0,
						pendingPayment: 0
					}
					this.usingMock = false
					this.usingDemo = false
				}
				this.demoBookerId = ''
			} finally {
				this.loading = false
			}
		},
		handleSearch() {
			this.pagination.page = 1
			this.isEmptyData = false
			this.fetchOrders()
		},
		handleReset() {
			this.filters.status = ''
			this.filters.dateRange = [
				moment().subtract(30, 'days').format('YYYY-MM-DD'),
				moment().format('YYYY-MM-DD')
			]
			this.pagination.page = 1
			this.isEmptyData = false
			this.fetchOrders()
		},
		handlePageChange(page) {
			// 验证页码的有效性
			const validPage = Math.max(1, parseInt(page) || 1)
			const maxPage = Math.ceil(this.pagination.total / this.pagination.pageSize) || 1
			const finalPage = Math.min(validPage, maxPage)
			
			console.log('[Orders] 页码变更:', {
				from: this.pagination.page,
				to: validPage,
				maxPage: maxPage,
				finalPage: finalPage,
				total: this.pagination.total,
				pageSize: this.pagination.pageSize
			})
			
			if (this.pagination.page !== finalPage) {
				this.pagination.page = finalPage
				this.fetchOrders({ page: finalPage })
			}
		},
		handlePageSize(size) {
			// 验证页面大小的有效性
			const validSizes = [10, 20, 50, 100]
			const validSize = validSizes.includes(parseInt(size)) ? parseInt(size) : 10
			
			console.log('[Orders] 页面大小变更:', {
				from: this.pagination.pageSize,
				to: validSize,
				total: this.pagination.total,
				currentPage: this.pagination.page
			})
			
			if (this.pagination.pageSize !== validSize) {
				this.pagination.pageSize = validSize
				// 重新计算当前页，确保不超过最大页数
				const maxPage = Math.ceil(this.pagination.total / validSize) || 1
				this.pagination.page = Math.min(this.pagination.page, maxPage) || 1
				this.fetchOrders({ page: this.pagination.page, pageSize: validSize })
			}
		},
		applyQuickFilter(value) {
			this.filters.status = value
			this.pagination.page = 1
			this.fetchOrders()
		},
		viewOrderDetail(order) {
			const orderId = order.orderNo || order.id
			if (!orderId) {
				this.$message.warning('订单号不存在')
				return
			}
			// 在新窗口打开订单详情
			const routeData = this.$router.resolve({
				name: 'MemberOrderDetail',
				params: { soShortNr: orderId }
			})
			window.open(routeData.href, '_blank')
		},
		getProductTagType(productCategoryId) {
			// 根据产品类型ID返回不同的标签颜色
			const typeMap = {
				2: 'success', // 酒店 - 绿色
				8: 'primary', // 国内机票 - 蓝色
				9: 'warning'  // 国际机票 - 橙色
			}
			return typeMap[productCategoryId] || 'info'
		},
		statusColor(status) {
			const map = {
				待支付: 'warning',
				待确认: 'warning',
				已支付: 'success',
				已出票: 'success',
				已完成: 'info',
				已取消: 'info'
			}
			return map[status] || 'info'
		},
		orderTypeLabel(type) {
			const map = {
				Flight: '机票',
				Hotel: '酒店',
				Visa: '签证',
				Insurance: '保险',
				Train: '火车票',
				Europe: '欧铁'
			}
			return map[type] || '订单'
		},
		// 将工具函数暴露给模板使用
		isUsingTestUser() {
			return isUsingTestUser()
		},
		getBookerID() {
			return getBookerID()
		},
		formatAmount(amount) {
			if (!amount) {
				return '0.00'
			}
			return Number(amount).toLocaleString('zh-CN', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			})
		},
		formatDate(value) {
			if (!value) {
				return '-'
			}
			return moment(value).format('YYYY-MM-DD HH:mm')
		}
	}
}
</script>

<style lang="scss" scoped>
.member-orders {
	padding: 0 12px 16px;

	.member-orders__container {
		max-width: 100%;
		margin: 0 auto;
		width: 100%;
		box-sizing: border-box;
	}

	.member-orders__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 12px;
		padding: 0 4px;

		h3 {
			margin: 0;
			font-size: 18px;
			font-weight: 600;
		}

		p {
			margin: 2px 0 0;
			color: #909399;
			font-size: 13px;
		}
	}

	.member-orders__metrics {
		display: flex;
		gap: 12px;

		.metric {
			min-width: 100px;
			padding: 10px 14px;
			border-radius: 8px;
			background: #f5f7fa;

			&__label {
				font-size: 12px;
				color: #909399;
				margin-bottom: 4px;
			}

			&__value {
				font-size: 18px;
				font-weight: 600;
				color: #303133;

				&--warning {
					color: #e6a23c;
				}
			}
		}
	}

	.member-orders__filters {
		margin: 12px 0;
		padding: 0 4px;

		.el-form {
			display: flex;
			flex-wrap: wrap;
			gap: 8px 16px;
			align-items: center;
		}

		.el-form-item {
			margin-bottom: 0;
		}
	}

	.member-orders__quick {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		margin-top: 8px;
		padding: 0 4px;
	}

	.member-orders__notice {
		margin-bottom: 12px;
	}

	.order-no {
		display: flex;
		align-items: center;
		gap: 6px;

		.order-no-link {
			font-weight: 500;
			cursor: pointer;
			font-size: 13px;

			&:hover {
				color: #409eff;
				text-decoration: underline;
			}
		}
	}

	.order-trip {
		color: #606266;
		font-size: 13px;
	}

	.order-amount {
		font-weight: 600;
		color: #f56c6c;
		font-size: 14px;
	}

	.order-date {
		color: #606266;
		font-size: 12px;
	}

	.member-orders__pagination {
		display: flex;
		justify-content: flex-end;
		margin-top: 12px;
		padding: 0 4px;
	}

	// 优化表格样式
	::v-deep .el-table {
		font-size: 13px;

		.el-table__header {
			th {
				padding: 10px 0;
				font-weight: 600;
			}
		}

		.el-table__body {
			td {
				padding: 10px 0;
			}
		}
	}

	// 优化卡片内边距
	::v-deep .el-card__body {
		padding: 16px;
	}

	::v-deep .el-card__header {
		padding: 14px 16px;
	}
}
</style>

